export default {
  EDIT_SUBSTANCE: 'EDIT_SUBSTANCE',
};
